import React from 'react'
import Dashboard from '../Dashboard/Dashboard';
import { VeltCommentTool, VeltSidebarButton } from '@veltdev/react';
import { on } from 'events';

function Main() {

    const [selectedDashboard, setSelectedDashboard] = React.useState('1');

    const dashboards = ['1', '2', '3', '4'];

    const onDashboardClick = (dashboard: any) => {
        if (selectedDashboard === dashboard) {
            return;
        }
        setSelectedDashboard(dashboard);
    };

    return (
        <>
            <div>
                {/* dashboards array */}
                <div className='d-flex justify-content-between align-items-center p-4'>
                    <div className='d-flex'>
                        {
                            dashboards.map((dashboard) => {
                                return (
                                    <div
                                        key={dashboard}
                                        onClick={() => onDashboardClick(dashboard)}
                                        className={`p-2 cursor-pointer ${dashboard === selectedDashboard ? 'selected' : ''}`}>
                                        Dashboard {dashboard}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='d-flex gap-4'>
                        <VeltCommentTool />
                        <VeltSidebarButton />
                    </div>
                </div>
                {
                    selectedDashboard &&
                    <div className='p-4'>
                        <Dashboard documentId={selectedDashboard} />
                    </div>
                }
            </div>
        </>
    )
}

export default Main;